import { ENTITY_TYPES } from '@sales-center/common'
import { AlertDialogSlide } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks'
import { deleteContact as deleteLeadContact } from '@user/store/lead/api'
import { deleteContact as deleteOpportunityContact } from '@user/store/opportunity/api'
import * as React from 'react'
import { useCallback, useState } from 'react'

interface Props {
  contactId: number | undefined
  entityId: number | undefined
  entityType: ENTITY_TYPES
  onClose?: () => void
  open?: boolean
  renderButton?: (onClick: () => void) => any
}

export function RemoveContact(props: Props) {
  const { contactId, entityId, entityType, onClose, open, renderButton } = props
  const [showConfirmPopup, setShowConfirmPopup] = useState<boolean>(false)

  //========== H O O K S ==========
  const dispatch = useAppDispatch()

  //========== E V E N T S ==========
  const buttonClick = useCallback(() => {
    setShowConfirmPopup(true)
  }, [])

  const cancelDelete = useCallback(() => {
    setShowConfirmPopup(false)
    if (onClose) {
      onClose()
    }
  }, [onClose])

  const deleteClick = useCallback(() => {
    if (contactId && entityId && entityType) {
      if (entityType === ENTITY_TYPES.Lead) {
        dispatch(
          deleteLeadContact({
            contactId: contactId,
            leadId: entityId,
          }),
        )
      }
      if (entityType === ENTITY_TYPES.Opportunity) {
        dispatch(
          deleteOpportunityContact({
            contactId: contactId,
            opportunityId: entityId,
          }),
        )
      }
      setShowConfirmPopup(false)
      if (onClose) {
        onClose()
      }
    }
  }, [contactId, dispatch, entityId, entityType, onClose])

  return (
    <>
      {renderButton && renderButton(buttonClick)}
      <AlertDialogSlide
        open={!!contactId && (open || showConfirmPopup)}
        title="Remove Contact?"
        message="Are you sure you want to remove this contact?"
        okButtonText="Remove"
        okClick={deleteClick}
        cancelButtonText="Cancel"
        cancelClick={cancelDelete}
      />
    </>
  )
}
